export default __webpack_public_path__ + "static/media/cauayan.03cad6a4.jpg";